module.exports = __webpack_public_path__ + "img/article_2_2.d6da1964.png";